import { HeadSchemaScript } from './HeadSchemaScript';

interface PodcastEpisodeSchemaProps {
  datePublished?: string;
  description?: string;
  timeRequired?: string;
  name?: string;
  url?: string;
  contentUrl?: string;
  partOfSeriesUrl?: string;
  partOfSeriesName?: string;
}
export const PodcastEpisodeSchema = ({
  partOfSeriesUrl,
  contentUrl,
  partOfSeriesName,
  ...props
}: PodcastEpisodeSchemaProps) => {
  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'PodcastEpisode',
    associatedMedia: {
      '@type': 'MediaObject',
      contentUrl: contentUrl,
    },
    partOfSeries: {
      '@type': 'PodcastSeries',
      name: partOfSeriesName,
      url: partOfSeriesUrl,
    },
    ...props,
  };

  return (
    <HeadSchemaScript
      id='add-podcast-episode-jsonld'
      schemaId='podcast-episode-jsonld'
      json={schema}
    />
  );
};

export default PodcastEpisodeSchema;
